"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Radio = function (_a) {
    var label = _a.label, checked = _a.checked, onChange = _a.onChange, className = _a.className, _b = _a.labelPosition, labelPosition = _b === void 0 ? 'left' : _b, disabled = _a.disabled;
    var handleChange = function (e) {
        if (!disabled && onChange) {
            onChange(e);
        }
        return false;
    };
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("ui-theme ui-checkbox", disabled && 'disabled', 'ui-checkbox-' + labelPosition, className) }, label ? (react_1.default.createElement("label", null,
        react_1.default.createElement("span", { className: "ui-checkbox-input-wrapper" },
            react_1.default.createElement("input", { type: "checkbox", className: "ui-checkbox-input", onChange: handleChange, disabled: disabled, checked: checked })),
        react_1.default.createElement("span", { className: "ui-checkbox-label" }, label))) : (react_1.default.createElement("input", { type: "checkbox", className: "ui-checkbox-input", onChange: handleChange, disabled: disabled, checked: checked }))));
};
exports.default = Radio;
